<template>
  <main class="mb-page" @click="pageClick">
    <div class="mb-visual" aria-hidden="true">
      <img
        v-for="layer in visualLayers"
        :key="layer.name"
        class="mb-art"
        :class="`mb-art-${layer.name}`"
        :src="layer.src"
        :style="layerStyle(layer, 0, 548)"
        alt=""
        draggable="false"
      />
    </div>
    <header class="mb-header">
      <img
        v-for="layer in headerLayers"
        :key="layer.name"
        class="mb-art"
        :class="`mb-art-${layer.name}`"
        :src="layer.src"
        :style="layerStyle(layer, 0, 98)"
        :alt="layer.name === 'logo' ? '黄果短剧 huangguo.com' : ''"
        draggable="false"
      />
    </header>
    <footer class="mb-footer">
      <div class="mb-footer-decoration" aria-hidden="true">
        <img
          v-for="layer in decorationLayers"
          :key="layer.name"
          class="mb-art"
          :src="layer.src"
          :style="layerStyle(layer, 0, 874)"
          alt=""
          draggable="false"
        />
      </div>
      <div class="mb-footer-art">
        <img
          v-for="layer in footerLayers"
          :key="layer.name"
          class="mb-art"
          :class="`mb-art-${layer.name}`"
          :src="layer.src"
          :style="layerStyle(layer, 466, 339)"
          alt=""
          draggable="false"
        />
        <button
          type="button"
          class="mb-download"
          :class="{ 'mb-download-android': !os.isPhone }"
          :aria-label="os.isPhone ? 'iOS下载' : 'Android下载'"
          @click.stop="onDownload($event)"
        >
          <img :src="os.isPhone ? iosButton : androidButton" alt="" />
        </button>
        <p class="mb-download-hint">下载免费预览更多短剧</p>
      </div>
      <site-links class="mb-site-links" :version="version" />
      <nav v-if="contactLinks.length" class="mb-contacts" aria-label="联系我们">
        <a
          v-for="contact in contactLinks"
          :key="contact.label"
          :href="contact.url"
          target="_blank"
          rel="noopener noreferrer"
          @click.stop.prevent="jumpUrl(contact.url, $event)"
          >{{ contact.label }}</a
        >
        <button type="button" @click.stop="openOnlineService($event)">
          客服
        </button>
      </nav>
    </footer>
    <install-guide
      :show="iosPromptShow || androidPromptShow"
      :type="iosPromptShow ? 'ios' : 'android'"
      @close="closeGuide"
      @help="openOnlineService"
    />
    <van-popup v-model="showTip" class="mb-safari-tip">
      <h2>温馨提示</h2>
      <p>请使用Safari浏览器进行下载</p>
      <p class="mb-current-url">{{ currUrl }}</p>
      <button type="button" @click.stop="doCopy">复制链接</button>
    </van-popup>
  </main>
</template>

<script>
import getCustomerServiceUrl from "@/api/getCustomerServiceUrl";
import {
  getDeviceType,
  getSystemType,
  getSystemVersion,
  getTraceId,
  landingPageClick
} from "@/utils/eventTracker";
import installGuide from "./installGuide";
import siteLinks from "./siteLinks";

const APPID = 4002;

const ART_LAYERS = [
  {
    name: "glow",
    src: require("@/assets/images/landingB/mobile-glow.webp"),
    x: -36.0,
    y: 675.0000291780052,
    width: 356.8224488009455,
    height: 353.5239559924812
  },
  {
    name: "film",
    src: require("@/assets/images/landingB/mobile-film.webp"),
    x: -367.77277553185286,
    y: -44.5341796875,
    width: 860.5453309718623,
    height: 562.0989056424587
  },
  {
    name: "character",
    src: require("@/assets/images/landingB/mobile-character.webp"),
    x: -67.0,
    y: -15.6669921875,
    width: 655.0,
    height: 436.6666564941406
  },
  {
    name: "ribbon-right",
    src: require("@/assets/images/landingB/mobile-ribbon-right.webp"),
    x: 103.0,
    y: 441.0,
    width: 343.0,
    height: 69.0
  },
  {
    name: "ribbon-left",
    src: require("@/assets/images/landingB/mobile-ribbon-left.webp"),
    x: 0.0,
    y: 448.0,
    width: 283.0,
    height: 69.0
  },
  {
    name: "foreground",
    src: require("@/assets/images/landingB/mobile-foreground.webp"),
    x: -41.00001308343781,
    y: -191.0,
    width: 604.9170083999161,
    height: 659.2394274052167
  },
  {
    name: "logo",
    src: require("@/assets/images/landingB/mobile-logo.webp"),
    x: 26.0,
    y: 26.0,
    width: 172.0,
    height: 42.85802459716797
  },
  {
    name: "script",
    src: require("@/assets/images/landingB/mobile-script.webp"),
    x: 187.17406495082446,
    y: 17.22630310058594,
    width: 85.41018450136403,
    height: 50.29074981117208
  },
  {
    name: "bottom",
    src: require("@/assets/images/landingB/mobile-bottom.webp"),
    x: 17.0,
    y: 781.0,
    width: 407.0,
    height: 154.0
  },
  {
    name: "subtitle",
    src: require("@/assets/images/landingB/mobile-subtitle.webp"),
    x: -26.198204,
    y: 480.801796,
    width: 421.396408,
    height: 313.396408
  },
  {
    name: "title",
    src: require("@/assets/images/landingB/mobile-title.webp"),
    x: 0.0,
    y: 466.0,
    width: 389.0,
    height: 217.0
  },
  {
    name: "categories",
    src: require("@/assets/images/landingB/mobile-categories.webp"),
    x: 18.0,
    y: 690.0,
    width: 355.0,
    height: 38.0
  }
];

export default {
  components: { installGuide, siteLinks },
  props: ["os", "configs", "switchData", "version"],
  data() {
    return {
      visualLayers: ART_LAYERS.filter(layer =>
        [
          "film",
          "character",
          "ribbon-right",
          "ribbon-left",
          "foreground"
        ].includes(layer.name)
      ),
      headerLayers: ART_LAYERS.filter(layer =>
        ["logo", "script"].includes(layer.name)
      ),
      footerLayers: ART_LAYERS.filter(layer =>
        ["subtitle", "title", "categories"].includes(layer.name)
      ),
      decorationLayers: ART_LAYERS.filter(layer =>
        ["glow", "bottom"].includes(layer.name)
      ),
      iosButton: require("@/assets/images/landingB/mobile-download-ios.webp"),
      androidButton: require("@/assets/images/landingB/mobile-download-android.webp"),
      androidPromptShow: false,
      iosPromptShow: false,
      showTip: false,
      currUrl: window.location.href,
      cTg: "",
      cPotato: "",
      cBusiness: "",
      cChannel: "",
      onlineServiceLoading: false,
      downloadTimer: null
    };
  },
  computed: {
    contactLinks() {
      return [
        { label: "TG", url: this.cTg },
        { label: "Potato", url: this.cPotato },
        { label: "商务", url: this.cBusiness },
        { label: "渠道", url: this.cChannel }
      ].filter(item => item.url);
    }
  },
  watch: {
    configs: {
      immediate: true,
      handler(configs) {
        this.cTg = this.cPotato = this.cBusiness = this.cChannel = "";
        (configs || []).forEach(item => {
          if (item.configType === "tg_group") {
            this.cTg = item.link;
          } else if (item.configType === "potato_group") {
            this.cPotato = item.link;
          } else if (item.configType === "sw_cooperate") {
            this.cBusiness = item.link;
          } else if (item.configType === "qd_cooperate") {
            this.cChannel = item.link;
          }
        });
      }
    }
  },
  beforeDestroy() {
    clearTimeout(this.downloadTimer);
  },
  methods: {
    layerStyle(layer, originY, height) {
      return {
        left: `${(layer.x / 402) * 100}%`,
        top: `${((layer.y - originY) / height) * 100}%`,
        width: `${(layer.width / 402) * 100}%`,
        height: `${(layer.height / height) * 100}%`
      };
    },
    pageClick(event) {
      let click_coordinates_x = event.clientX;
      let click_coordinates_y = event.clientY;
      let tab_name = "主页";
      landingPageClick(this, {
        tab_key: "main",
        tab_name,
        click_coordinates_x,
        click_coordinates_y
      });
    },
    checkIsSafari() {
      const ua = (this.os.userAgent || "").toLowerCase();
      return (
        ua.indexOf("safari") !== -1 &&
        ua.indexOf("browser") === -1 &&
        ua.indexOf("android") === -1 &&
        !/crios|fxios|edgios|opios|micromessenger/.test(ua)
      );
    },
    onDownload(event) {
      if (this.os.isPhone) {
        if (this.switchData.shopIosDownUrl) {
          this.getApkInfo("shopIos", event);
          return;
        }
        if (!this.checkIsSafari()) {
          this.showTip = true;
          this.trackDownload(event);
          return;
        }
        this.getApkInfo("ios", event);
        return;
      }
      this.getApkInfo("android", event);
    },
    trackDownload(event) {
      landingPageClick(this, {
        tab_name: "下载按钮",
        tab_key: "download",
        click_coordinates_x: event.clientX,
        click_coordinates_y: event.clientY
      });
    },
    closeGuide() {
      this.iosPromptShow = false;
      this.androidPromptShow = false;
    },
    doCopy() {
      this.$copyText(this.currUrl).then(
        () => {
          this.showTip = false;
        },
        () => {
          this.showTip = true;
        }
      );
    },
    getApkInfo(type, event) {
      clearTimeout(this.downloadTimer);
      this.$emit("recordClick", type);
      this.trackDownload(event);
      if (type === "shopIos") {
        this.closeGuide();
        // Open the store within the click gesture so Safari permits the new tab.
        this.$emit("getApkInfo", type);
        return;
      }
      this.iosPromptShow = type === "ios";
      this.androidPromptShow = type === "android";
      this.downloadTimer = setTimeout(() => {
        this.$emit("getApkInfo", type);
      }, 500);
    },
    openMobileCompatibleUrl(url) {
      if (!url) {
        return;
      }
      window.location.href = url;
    },
    async openOnlineService(event) {
      const click_coordinates_x = event.clientX;
      const click_coordinates_y = event.clientY;
      const userAgent = this.os.userAgent || "";
      landingPageClick(this, {
        tab_name: "在线客服",
        tab_key: "customer_service",
        click_coordinates_x,
        click_coordinates_y
      });
      if (this.onlineServiceLoading) {
        return;
      }
      this.onlineServiceLoading = true;
      try {
        const res = await getCustomerServiceUrl({
          uid: this.$route.query.uid || getTraceId(),
          appId: APPID,
          deviceType: getDeviceType(userAgent),
          systemType: getSystemType(userAgent),
          systemVersion: getSystemVersion(userAgent)
        });
        const serviceUrl = res && res.data && res.data.data;
        if (serviceUrl) {
          this.openMobileCompatibleUrl(serviceUrl);
          return;
        }
        if (this.cChannel) {
          this.openMobileCompatibleUrl(this.cChannel);
          return;
        }
      } catch (error) {
        if (this.cChannel) {
          this.openMobileCompatibleUrl(this.cChannel);
          return;
        }
        this.$toast("客服暂时无法连接，请稍后重试");
      } finally {
        this.onlineServiceLoading = false;
      }
    },
    jumpUrl(url, event) {
      landingPageClick(this, {
        tab_key: "contact",
        tab_name: "联系我们",
        click_coordinates_x: event.clientX,
        click_coordinates_y: event.clientY
      });
      window.open(url, "_blank", "noopener,noreferrer");
    }
  }
};
</script>

<style lang="scss" scoped>
.mb-page {
  --mb-layout-width: min(100vw, 70vh);
  --mb-viewport-height: 100vh;
  position: fixed;
  inset: 0;
  width: 100%;
  height: 100%;
  overflow: hidden;
  background: #150403 url("~@/assets/images/landingB/mobile-background.webp")
    center / cover no-repeat;
  color: #f8dfa0;
}
@supports (height: 100dvh) {
  .mb-page {
    --mb-layout-width: min(100vw, 70dvh);
    --mb-viewport-height: 100dvh;
    height: 100dvh;
  }
}
.mb-visual {
  position: absolute;
  top: env(safe-area-inset-top, 0px);
  left: 50%;
  width: var(--mb-layout-width);
  aspect-ratio: 402 / 548;
  transform: translateX(-50%);
  pointer-events: none;
}
.mb-header {
  position: fixed;
  z-index: 2;
  top: env(safe-area-inset-top, 0px);
  left: 50%;
  width: var(--mb-layout-width);
  aspect-ratio: 402 / 98;
  transform: translateX(-50%);
  pointer-events: none;
}
.mb-footer {
  position: fixed;
  z-index: 1;
  /* Keep the requested offset in CSS pixels rather than converting it to rem. */
  /* prettier-ignore */
  bottom: 0PX;
  left: 50%;
  width: var(--mb-layout-width);
  padding-bottom: calc(
    clamp(
        16px,
        var(--mb-viewport-height) - var(--mb-layout-width) * 1.83830846,
        var(--mb-layout-width) * 0.3358209
      ) + env(safe-area-inset-bottom, 0px)
  );
  transform: translateX(-50%);
}
.mb-footer::before {
  position: absolute;
  inset: -12% 0 0;
  background: linear-gradient(
    180deg,
    rgba(21, 4, 3, 0),
    rgba(21, 4, 3, 0.8) 35%,
    #150403
  );
  content: "";
  pointer-events: none;
}
.mb-footer-art {
  position: relative;
  width: 100%;
  aspect-ratio: 402 / 339;
}
.mb-footer-decoration {
  position: absolute;
  left: 0;
  bottom: 0;
  width: 100%;
  aspect-ratio: 402 / 874;
  pointer-events: none;
}
.mb-site-links {
  position: relative;
  width: 89.303483%;
  margin-left: 5.472637%;
}
.mb-art {
  position: absolute;
  display: block;
  pointer-events: none;
  user-select: none;
}
.mb-art-logo {
  z-index: 1;
}
.mb-art-script {
  z-index: 0;
}
.mb-download {
  position: absolute;
  left: 3.9801%;
  top: 79.351032%;
  width: 48.756219%;
  height: 17.20059%;
  padding: 0;
  border: 0;
  background: transparent;
  cursor: pointer;
  -webkit-appearance: none;
}
.mb-download img {
  display: block;
  width: 100%;
  height: 100%;
}
.mb-download:active {
  transform: scale(0.97);
}
.mb-download-hint {
  position: absolute;
  left: 53.233831%;
  top: 81.120944%;
  width: 42.288557%;
  margin: 0;
  color: #f5e69d;
  font-family: "PingFang SC", "Microsoft YaHei", sans-serif;
  font-size: calc(var(--mb-layout-width) * 0.04228856);
  line-height: 2;
  text-align: center;
  white-space: nowrap;
  text-shadow: 0 1px #170403;
}
.mb-download:focus-visible,
.mb-contacts a:focus-visible,
.mb-contacts button:focus-visible {
  outline: 2px solid #ffe6a1;
  outline-offset: 3px;
}
.mb-contacts {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-wrap: wrap;
  gap: 16px;
  padding: 4px 8px 0;
}
.mb-contacts a,
.mb-contacts button {
  border: 0;
  padding: 4px 0;
  background: transparent;
  color: #f8dfa0;
  font-size: 12px;
  line-height: 18px;
}
.mb-safari-tip {
  width: 300px;
  padding: 24px 18px;
  border-radius: 12px;
  color: #222;
  text-align: center;
  box-sizing: border-box;
  h2 {
    margin-bottom: 24px;
    font-size: 18px;
  }
  p {
    font-size: 14px;
    line-height: 22px;
  }
  .mb-current-url {
    margin-top: 16px;
    overflow-wrap: anywhere;
  }
  button {
    margin-top: 24px;
    padding: 8px 36px;
    border: 0;
    border-radius: 20px;
    background: #a35419;
    color: #fff;
    font-size: 15px;
  }
}
@supports not (aspect-ratio: 1 / 1) {
  .mb-visual {
    height: calc(var(--mb-layout-width) * 1.363184);
  }
  .mb-header {
    height: calc(var(--mb-layout-width) * 0.243781);
  }
  .mb-footer-art {
    height: calc(var(--mb-layout-width) * 0.843284);
  }
  .mb-footer-decoration {
    height: calc(var(--mb-layout-width) * 2.174129);
  }
}
</style>
